<div class="p-col-12 row" style="background-color: #f2f9ff; min-height: 100%;">
  <div class="p-col-8 p-offset-2">
    <div class="container">
      <div class="wrapper">
          <h2 class="title"> Tracking</h2>
          <p class="desc">Enter up to 10 tracking numbers to track your orders</p>
          <div class="p-col-12" style="display: inline-block;">
            <div class="p-col-10" style="float: left;">
              <p-chips [(ngModel)]="trackNumbers" class="chips" unique="true" >
                <ng-template let-item pTemplate="item">
                    {{item}} <i class="pi pi-map-marker p-ml-2"></i>
                </ng-template>
            </p-chips>

            </div>
            <div class="p-col-2" style="float: left;">
          <button pButton class="track" type="button" [disabled]="trackNumbers.length===0  " label="Track" (click)="track()"></button>
            </div>
          </div>
          <p class="text-danger" style="font-weight: bold;"  *ngIf=" trackNumbers.length===0 " > Press ENTER to add Tracking number </p>
      </div>
      <hr>

      <div  *ngIf=" trackingTable.length>0 " class="tabs" style="height:450px; overflow:auto; overflow-y:auto; overflow-wrap: anywhere;">
        <div class="tab"  *ngFor="let track of trackingTable">
          <input type="checkbox" id="{{track.trackingNumbers}}"  style="display: none;" (click)="check(track)">
          <label class="tab-label" for="{{track.trackingNumbers}}">

            <i *ngIf="track.trackingInformation[0]?.status=='Delivered ' || track.trackingInformation[0]?.status =='Returning' || track.trackingInformation[0]?.status =='Returned'"
            class="pi pi-check" style="float: left;"></i>

           <i  *ngIf="track.trackingInformation[0]?.status =='Processing' || track.trackingInformation[0]?.status =='Pick Up'"
           class="pi pi-check" style="float: left;background-color: #003cff"></i>
           <i  *ngIf="track.trackingInformation[0]?.status =='Undelivered' || track.trackingInformation[0]?.status =='Expired' "
           class="pi pi-check" style="float: left;background-color: #c40000"></i>
           <i  *ngIf="track.trackingInformation[0]?.status =='Exception'"
           class="pi pi-check" style="float: left;background-color: #fbff00"></i>
           <i  *ngIf="track.trackingInformation[0]?.status =='InTransit'"  class="pi pi-check" style="float: left;background-color: #00b7ff"></i>
           <i  *ngIf="track.trackingInformation[0]?.status === null"  class="pi pi-check" style="float: left;background-color: black"></i>
            <p class="title-order" style="float: left;">{{track.trackingNumbers}}</p>

            <p-chip class="parent" *ngIf="track.trackingInformation[0]?.status === null" label='Not Found' ></p-chip>
            <p-chip class="parent" *ngIf="track.trackingInformation[0]?.status !== null" label={{track.trackingInformation[0]?.status}}></p-chip>
          </label>

          <ng-container>
          <div *ngIf="track.checked" class="tab-content">
            <div *ngFor="let item of track.trackingInformation">
              <ul style="margin-left: 50px;">
                <li class="line-status">
                  <i *ngIf="item.status == 'Delivered' " class="pi pi-check-circle"></i>
                  <i *ngIf="item.status == 'Returning' " class="pi pi-check-circle"></i>
                  <i *ngIf="item.status == 'Returned' " class="pi pi-check-circle"></i>
                  <i *ngIf="item.status == 'PickUP'  || item.status == 'Processing'" style="color: #003cff" class="pi pi-clock"></i>
                  <i *ngIf=" item.status == 'InTransit'" class="pi pi-clock" style="color: #00b7ff" ></i>
                  <i  class="pi pi-exclamation-circle" *ngIf="track.trackingInformation[0]?.status =='Undelivered' || track.trackingInformation[0]?.status =='Expired' " style="color: #c40000" ></i>
                  <i *ngIf="item.status == 'NotFound'  || item.status == null " style="color: black" class="pi pi-exclamation-circle"></i>
                  <i *ngIf="item.status == 'Exception'" class="pi pi-times-circle"  style="color: #fbff00"></i>
                  <p class="list-text"*ngIf="item.status != null " style="font-weight: bold;" >{{item.status}}</p>
                  <p class="list-text"*ngIf="item.status == null " style="font-weight: bold;" >{{item.message}} </p>
                  <br>
                  <p class="list-text" *ngIf="item.status != null " > {{item.updateAt | date: 'dd/MM/yyyy' }} &nbsp;&nbsp;&nbsp;&nbsp; {{item.location}} &nbsp;&nbsp;  {{item.message}} </p>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
        </div>
      </div>
  </div>
  </div>
</div>

